import styled from '@emotion/styled'

export const UISpinnerContainer = styled.div`
  display: flex;
  height: 498px;
  justify-content: center;
  align-items: center;
`